
export const doctorsNameToIdMap = {
    "Dr. Vishwanath": 1,
    "Dr. Sushma": 2,
    // ...add more
  };
  